export const options = [
  {
    id: 1,
    code: "pd",
    name: "positions_directory",
    description_lang_key: "positions_directory",
    path: "/editor/directories/pd/",
    permissions: "employeeAccounting.position.get",
  },
  {
    id: 2,
    code: "directions",
    name: "directions",
    description_lang_key: "directions",
    path: "/editor/directories/ed/",
    permissions: "directions.directions.get",
  },
  {
    id: 3,
    code: "combination-rules",
    name: "combination_rules",
    description_lang_key: "combination_rules",
    path: "/editor/directories/combination-rules/",
    permissions: "combinationRules.rules.get",
  },
];

export const headerTableDirections = [
  "name",
  "status",
  "createdAt",
  "updatedAt",
];
const headerTablePDRu = [
  "positionCode",
  "titlePosition",
  "belongingDirectionID",
  "status",
  "createdAt",
  "updatedAt",
  "RequiredEmail",
  "showInZd",
  "jobDescriptionIsRequired",
];
const headerTablePDen = [
  "positionCode",
  "titlePositionEn",
  "belongingDirectionID",
  "status",
  "createdAt",
  "updatedAt",
  "RequiredEmail",
  "showInZd",
  "jobDescriptionIsRequired",
];

export const getTableHeader = (language = "ru") => {
  switch (language) {
    case "en":
      return headerTablePDen;
    case "ru":
    default:
      return headerTablePDRu;
  }
};

export const positionsDirectorySortableColumns = [
  "positionCode",
  "titlePosition",
  "titlePositionEn",
  "belongingDirectionID",
  "status",
  "RequiredEmail",
  "showInZd",
  "jobDescriptionIsRequired",
];

export const optionsStatus = [
  { value: undefined, label: "Не выбрано" },
  { value: "inactive", label: "Неактивный" },
  { value: "active", label: "Активный" },
];
